import OMT_UI_SquareButton, { BUTTONCOLOURS } from "../../OMT_UI/OMT_UI_SquareButton";

G.TreasureHunt = G.TreasureHunt || {};

G.TreasureHunt.TreasureHuntEventPanel = function() {
  Phaser.Group.call(this, game);

  this._init();
};

G.TreasureHunt.TreasureHuntEventPanel.prototype = Object.create(Phaser.Group.prototype);

G.TreasureHunt.TreasureHuntEventPanel.prototype._init = function() {
  // imports
  var treasureHuntMgr = G.TreasureHunt.treasureHuntMgr;
  var utils = G.Utils;
  var ClockTimer = G.CommonObjects.ClockTimer;

  var contentGroup = this;

  var missionBanner = G.makeImage(0, 0, "mission_title_banner", [0.5, 0], contentGroup);
  var treasureHuntTxt = contentGroup.add(new G.Text(0, 19, OMT.language.getText("Treasure Hunt"), {
    style: "font-white",
    fontSize: 25,
  }, 0.5, 200));

  var bg = G.makeImage(0, 30, "treasure_hunt_banner", [0.5, 0], contentGroup);

  // Helper function for opening new gate window to avoid "no-loop-func" ESLint rule
  const _openGateWindow = (gateObject, gateInstance, gateId, showTreasureHuntWindow) => {
    G.sb('pushWindow').dispatch(['gateNew', {
      gateObject,
      onOpenCallback: () => {
        gateInstance.unlock();
        gateInstance.onOpen.dispatch(gateId, showTreasureHuntWindow);
      },
    }]);
  };

  const onClick = async () => {
    // Check unopened gate status first
    const { gatesMgr } = G.Helpers;
    const nextLevel = G.saveState.getLastPassedLevelNr() + 1;
    let gateData = gatesMgr.getFirstClosedGateData();

    const canUnlock = []; // gates that can be unlocked automatically
    const cannotUnlock = { // gates that can't be unlocked automatically
      gateObject: null,
      gateId: null,
    };
    let scrollToLvl = nextLevel;

    // Check for which gates can be unlocked automatically
    while (gateData && nextLevel >= gateData.lvlNr) {
      const gateObject = gatesMgr.getGateObject(gateData.id);
      gatesMgr.activateGate(gateData.id);

      if (gateObject.isReadyToOpen()) {
        canUnlock.push(gateData.id);
        scrollToLvl = gateData.lvlNr;
      } else {
        cannotUnlock.gateObject = gateObject;
        cannotUnlock.gateId = gateData.id;
        scrollToLvl = gateData.lvlNr;
        break;
      }

      gateData = gatesMgr.getNextGateData(gateData.id);
    }

    // Scroll to furthest gate possible if next level is behind gate
    gateData = gatesMgr.getFirstClosedGateData();
    if (gateData && nextLevel >= gateData.lvlNr) {
      // Close side panel if there is a gate with unmet star requirements
      if (game.state.getCurrentState().worldSidePanel.getSidePanelState()) {
        game.state.getCurrentState().worldSidePanel.toggleSidePanel();
      }

      await new Promise((resolve) => game.state.getCurrentState().map.scrollToPoint({ lvlNr: scrollToLvl - 1 }, () => resolve(), this));
    }

    // Try to unlock all gates that meet star requirements on their behalf
    for (const gateId of canUnlock) {
      // Dispatch and remove the open gate signal only if the gate exists
      // Don't push the Treasure Hunt Window since it will be pushed later
      if (gatesMgr.instances[gateId].onOpen) {
        gatesMgr.instances[gateId].onOpen.dispatch(gateId, false);
      } else {
        console.warn(`Treasure Hunt side panel tried to open Gate #${gateId}, but it doesn't exist`);
        return;
      }
    }

    // If there is a gate with unmet star requirements, show new gate Window
    if (cannotUnlock.gateObject) {
      // Determine if the treasure hunt window should be shown
      const nextGateLvl = gatesMgr.getNextGateData(cannotUnlock.gateId).lvlNr;
      const showTreasureHuntWindow = nextGateLvl > nextLevel;

      _openGateWindow(
        cannotUnlock.gateObject,
        gatesMgr.instances[cannotUnlock.gateId],
        cannotUnlock.gateId,
        showTreasureHuntWindow,
      );
      return;
    }

    // Show treasure hunt window
    if (treasureHuntMgr.isEventActive()) {
      const lvlIndex = treasureHuntMgr.getTreasureHuntLevelIndex();
      if (G.saveState.getLives() === 0 && G.saveState.getUnlimitedLivesSec() === 0) {
        G.sb('pushWindow').dispatch(['notEnoughLives', {
          openLevelPopUp: true,
          lvlIndex,
          levelPopUpLayerName: G.WindowMgr.LayerNames.AboveHighScorePanel,
        }], false, G.WindowMgr.LayerNames.AboveHighScorePanel);
      } else if (lvlIndex !== null) {
        G.sb('pushWindow').dispatch(['level', lvlIndex]);
      }
      // open level
    } else if (treasureHuntMgr.isEventReadyToStart()) {
      G.sb('pushWindow').dispatch('treasureHuntEvent');
    }
  };

  var greenButton = new OMT_UI_SquareButton(92, 150, {
    button: {
      tint: BUTTONCOLOURS.green,
      dimensions: {
        width: 137,
        height: 70,
      },
    },
    text: {
      string: '',
      textStyle: { style: 'font-white', fontSize: 44 },
      dimensionMods: {
          height: 0.9,
          width: 0.9,
        },
    },
    options: {
      clickFunction: {
        onClick: onClick.bind(this),
      },
      cacheButton: false,
    },
  });
  contentGroup.add(greenButton);

  if (treasureHuntMgr.isEventActive()) {
    initEventActive();
  } else if (treasureHuntMgr.isEventReadyToStart()) {
    initEventReadyToPlay();
  }

  utils.cleanUpOnDestroy(this,
    treasureHuntMgr.onEventStart.add(initEventActive));

  // DEBUG
  return {
    initEventReadyToPlay: initEventReadyToPlay,
    initEventActive: initEventActive,
  }

  function initEventReadyToPlay() {
    greenButton.setText(OMT.language.getText("Join!"));
  };

  function initEventActive() {
    greenButton.setText(OMT.language.getText("Play"));
    var timer = contentGroup.add(new ClockTimer(-82, 150));
    var progressData = treasureHuntMgr.getProgressData();
    timer.setEndDate(progressData.endDate, true);
  };

};

G.TreasureHunt.TreasureHuntEventPanel.prototype.getContentHeight = function() {
  return 180;
};